import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import * as api from '../api/loginApi';

import { useTurnstile } from './useTurnstile';

export const useForgotPassword = () => {
    const intl = useIntl();
    const { getToken: getTurnstileToken, resetWidget: resetTurnstile } = useTurnstile(
        'turnstile-widget-forgot',
        'forgot_password',
    );
    const [emailSent, setEmailSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>();

    const mutation = useMutation({
        mutationFn: async (email: string) => {
            const turnstileToken = getTurnstileToken();
            return api.postForgotPassword({ email, turnstileToken });
        },
        onSuccess: (data) => {
            if (data.success) {
                setEmailSent(true);
                setErrorMessage(undefined);
            } else {
                resetTurnstile();
                setErrorMessage(
                    data.errorMessage ??
                        intl.formatMessage({
                            id: 'login.forgotPassword.error.requestFailed',
                            defaultMessage: 'Request failed',
                        }),
                );
            }
        },
    });

    const submitForgotPassword = (email: string) => {
        setErrorMessage(undefined);
        mutation.mutate(email);
    };

    const reset = () => {
        setEmailSent(false);
        setErrorMessage(undefined);
        mutation.reset();
    };

    return {
        emailSent,
        isLoading: mutation.isPending,
        error: errorMessage ?? mutation.error?.message,
        submitForgotPassword,
        reset,
    };
};
